import React from 'react'

import Playground from './Playground'

const App = () => {
    return (
        <Playground />
    )
}

export default App
